<template>
	<div v-if="restListHeader.pageBanner.copy" class="outer sticky-wrapper">
		<content-container>
			<a
				v-if="restListHeader.pageBanner.url"
				:href="restListHeader.pageBanner.url"
				target="_blank"
				class="inner"
			>
				<div v-if="restListHeader.pageBanner.title" class="title">
					{{ restListHeader.pageBanner.title }}
				</div>
				<div v-else class="title">
					Hey, {{ restListHeader.pageBanner.titleLocation }}.
				</div>
				<div class="copy-wrapper">
					<div v-if="restListHeader.pageBanner.copy" class="copy">
						{{ restListHeader.pageBanner.copy }}
					</div>
					<div class="banner-icon-wrapper">
						<icon-base
							width="10px"
							height="10px"
							:iconName="'Go To Link'"
							:id="'goToPageBannerLink'"
						>
							<icon-arrow-right />
						</icon-base>
					</div>
				</div>
			</a>
			<div v-else class="inner">
				<div v-if="restListHeader.pageBanner.title" class="title">
					{{ restListHeader.pageBanner.title }}
				</div>
				<div v-else class="title">
					Hey, {{ restListHeader.pageBanner.titleLocation }}.
				</div>
				<div v-if="restListHeader.pageBanner.copy" class="copy">
					{{ restListHeader.pageBanner.copy }}
				</div>
			</div>
		</content-container>
	</div>
</template>

<script>
import ContentContainer from "./ContentContainer.vue";
import IconBase from "./IconBase.vue";
import IconArrowRight from "./icons/IconArrowRight.vue";

import { mapState } from "vuex";

export default {
	name: "PageBanner",
	components: {
		ContentContainer,
		IconBase,
		IconArrowRight,
	},
	computed: {
		...mapState({
			restListHeader: (state) => state.restList.restListHeader,
		}),
	},
};
</script>

<style scoped lang="scss">
.outer {
	background-color: $royal;
	padding: 14px 0;
}

.inner {
	display: flex;
	flex-wrap: wrap;
	align-items: center;

	width: 100%;
	text-decoration: none;
}

.title,
.copy {
	display: inline-block;
	vertical-align: middle;
	color: $white;
}

.title {
	color: $gold;
	font-size: 2.3rem;
	font-weight: 900;
	margin-right: 20px;
}

.copy-wrapper {
	display: flex;
	align-items: ceil($number: 0);
}

.banner-icon-wrapper {
	@include transition(transform);
	flex: 0 0 auto;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background-color: $white;
	color: $black;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-left: 20px;
	margin-top: 5px;

	.inner:hover &,
	.inner:focus & {
		transform: translate(5px, 0);
	}
}
.copy {
	margin-top: 5px;
	font-size: 16px;
}
</style>